import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const getSuiteStatusesDone = (_, { payload }) => {
    return [
        ...payload
    ]
}

const initialState = [];

export default createReducer(initialState, {
    [TYPES.GET_SUITE_STATUSES_DONE]: getSuiteStatusesDone
});